import styled from "styled-components";

export const InfoHeadText = styled.text`
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
  font-weight: bold;
  color: #6e6d7a;
  text-align: left;
`
